var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 16,
    fill: "#F4F6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 18L32 30V56C32 77.3333 43.3333 95.3333 60 102C76.6667 95.3333 88 77.3333 88 56V30L60 18Z",
    fill: "#E4ECFF",
    stroke: "#3E64FF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46C54 42.6863 56.6863 40 60 40C63.3137 40 66 42.6863 66 46C66 49.3137 63.3137 52 60 52C56.6863 52 54 49.3137 54 46Z",
    fill: "#3E64FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 72C46 65.3726 51.3726 60 58 60H62C68.6274 60 74 65.3726 74 72V78H46V72Z",
    fill: "#3E64FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42V56C40 74.6667 48 90 60 96",
    stroke: "#3E64FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42V56C80 74.6667 72 90 60 96",
    stroke: "#3E64FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.f5ca6575939e5fbbfe9bc7ce996ce902.svg";
export { ForwardRef as ReactComponent };